import styled from "styled-components";

export const StyledHeaderTitle = styled.div`
    &.cmp_headerTitle {
        min-height:100px;
        margin-top:50px;
        margin-bottom:25px;
        i{
            padding-right: 20px;
        }  
    }

    &.cmp_slimHeaderTitle {
        margin-top: 15px;
    }

`;
